var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "md:pl-10 w-full md:pr-10" }, [
    _c(
      "div",
      { staticClass: "mb-6" },
      [
        _c("label", { ref: "image", attrs: { for: "image" } }, [
          _vm._v("\n            Resource Photo "),
          _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
          _vm._v(" "),
          _c("div", { staticClass: "text-sm font-sans-book mb-5" }, [
            _vm._v(
              "Please upload a horizontal/landscape image (JPEG or PNG), ideally 1424 pixels x 862 pixels. Image must NOT have any text. You can also drag and drop directly onto the Choose File button."
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.resource && _vm.resource.image
          ? _c("div", [
              _c("img", {
                staticClass: "h-48 mb-2",
                attrs: { src: _vm.resource.image },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: _vm.imageValidate,
              expression: "imageValidate",
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.newImage,
              expression: "form.newImage",
            },
          ],
          attrs: { id: "image", type: "hidden", name: "image" },
          domProps: { value: _vm.form.newImage },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.form, "newImage", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "vue-dropzone",
          {
            ref: "dropzone",
            attrs: {
              id: "dropzone",
              options: _vm.dropzoneOptions,
              useCustomSlot: true,
            },
            on: {
              "vdropzone-success": _vm.uploaded,
              "vdropzone-error": _vm.updateImageErrorMessage,
              "vdropzone-removed-file": _vm.resetImage,
            },
          },
          [
            _c("p", [
              _vm._v(
                "You may drag-and-drop an image here. File size must be less than 4 MB."
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.errors.has("image")
          ? _c("span", { staticClass: "text-lg error text-error-red" }, [
              _vm._v(_vm._s(_vm.errors.first("image"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.imageError
          ? _c("span", { staticClass: "text-lg error text-error-red" }, [
              _vm._v(_vm._s(_vm.imageError)),
            ])
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mb-6" }, [
      _c("label", { ref: "teaser", attrs: { for: "teaser" } }, [
        _vm._v("\n            Teaser "),
        _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
        _vm._v(" "),
        _c("div", { staticClass: "text-sm font-sans-book" }, [
          _vm._v(
            "170 characters maximum, including spaces. This brief teaser copy of your resource listing on the search results page. It should be enticing and make it clear to visitors what your particular resource is about."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.teaser,
            expression: "form.teaser",
          },
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|max:170",
            expression: "'required|max:170'",
          },
        ],
        staticClass:
          "w-full mt-3 p-4 overflow-y-scroll border border-black h-48 bg-transparent",
        attrs: { name: "teaser" },
        domProps: { value: _vm.form.teaser },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.form, "teaser", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-sm font-sans-italic text-gray-dark" }, [
        _vm._v("Character count: " + _vm._s(_vm.characterCount)),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errors.has("teaser"),
              expression: "errors.has('teaser')",
            },
          ],
          staticClass: "error text-error-red text-lg",
        },
        [_vm._v(_vm._s(_vm.errors.first("teaser")))]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-6" },
      [
        _c("label", { ref: "description", attrs: { for: "description" } }, [
          _vm._v("\n            Enter Resource Information Here "),
          _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
          _vm._v(" "),
          _c("div", { staticClass: "text-sm font-sans-book mb-2" }, [
            _vm._v(
              "Use this field to provide visitors a compelling description of your resource or to write a brand new resource right here (an article, an essay, a poem, you name it!)"
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-sm font-sans-book" }, [
            _vm._v(
              "Please note that all hyperlinks MUST begin with https:// in order for them to link properly. For example, type in https://letsreimagine.org rather than letsreimagine.org."
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("vue-editor", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'",
            },
          ],
          attrs: { editorToolbar: _vm.descriptionToolbar, name: "description" },
          model: {
            value: _vm.form.description,
            callback: function ($$v) {
              _vm.$set(_vm.form, "description", $$v)
            },
            expression: "form.description",
          },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("description"),
                expression: "errors.has('description')",
              },
            ],
            staticClass: "error text-error-red text-lg",
          },
          [_vm._v(_vm._s(_vm.errors.first("description")))]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mb-6" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.inspiration,
            expression: "form.inspiration",
          },
        ],
        staticClass:
          "w-full mt-3 p-4 overflow-y-scroll border border-black h-48 bg-transparent",
        attrs: { name: "inspiration" },
        domProps: { value: _vm.form.inspiration },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.form, "inspiration", $event.target.value)
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-6 flex flex-wrap justify-start md:justify-end" },
      [
        _c(
          "button",
          {
            staticClass: "button",
            class: { "opacity-50 cursor-not-allowed": _vm.saving },
            attrs: { disabled: _vm.saving },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.save.apply(null, arguments)
              },
            },
          },
          [_vm.saving ? [_vm._v("Processing...")] : [_vm._v("Save")]],
          2
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "pr-0 md:pr-4 pb-4 md:pb-0 w-full md:w-auto",
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { "opacity-50 cursor-not-allowed": _vm.saving },
            attrs: { disabled: _vm.saving },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.saveNext.apply(null, arguments)
              },
            },
          },
          [_vm._v("Save & Next")]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "teaser" } }, [
      _vm._v("\n            What inspired this?\n            "),
      _c("div", { staticClass: "text-sm font-sans-book" }, [
        _vm._v(
          "Posts that have personal backstories are more engaging and meaningful. Who or what inspired you to create what you’ve shared here? How did you come up with it? Be vivid. This is your chance to celebrate who or what is at the root of your offering."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }